<template>
  <v-dialog v-model="dialog" persistent scrollable="">
    <v-card>
      <v-card-title class="pa-5 bg-D5EEED">
        <v-btn :x-small="almost_mobile" icon disabled
          ><v-icon>mdi-clear</v-icon></v-btn
        >
        <span class="font-24" style="color: #4ba69d; font-weight: bold"
          >ข้อมูลพนักงาน</span
        >
        <v-spacer></v-spacer>
        <v-btn icon color="#4BA69D" @click="close()" small>
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="py-4">
        <v-row>
          <v-col cols="12" class="pa-0">
            <v-row class="bg-D5EEED">
              <v-col
                :style="
                  almost_mobile ? 'margin-left: 32px;' : 'margin-left: 64px;'
                "
              >
                <v-row>
                  <v-col cols="12" xs="6" sm="6" md="6" lg="6">
                    <span class="custom-text">รหัสพนักงาน : </span>
                    <span class="custom-text ml-2">
                      {{
                        selectPatient.employee_id
                          ? selectPatient.employee_id
                          : "-"
                      }}
                    </span>
                  </v-col>
                  <v-col cols="12" xs="6" sm="6" md="6" lg="6">
                    <span class="custom-text">แผนก : </span>
                    <span class="custom-text ml-2">
                      {{
                        selectPatient.department
                          ? selectPatient.department
                          : "-"
                      }}
                    </span>
                  </v-col>
                  <v-col cols="12" xs="6" sm="6" md="6" lg="6">
                    <span class="custom-text">ชื่อ-สกุล : </span>
                    <span class="custom-text ml-2">{{
                      selectPatient.fullname || ""
                    }}</span>
                  </v-col>
                  <v-col cols="12" xs="6" sm="6" md="6" lg="6">
                    <span class="custom-text">หมายเลขโทรศัพท์ : </span>
                    <span class="custom-text ml-2">{{
                      selectPatient.mobile
                    }}</span>
                  </v-col>
                  <v-col cols="12" xs="6" sm="6" md="4" lg="4">
                    <span class="custom-text">เพศ : </span>
                    <span class="custom-text ml-2">{{
                      genderPerson(selectPatient.account_title_th)
                    }}</span>
                  </v-col>
                  <v-col cols="12" xs="6" sm="6" md="4" lg="4">
                    <span class="custom-text">วัน/เดือน/ปีเกิด : </span>
                    <span class="custom-text ml-2">{{
                      formatDate(selectPatient.birth_date)
                    }}</span>
                  </v-col>
                  <v-col cols="12" xs="6" sm="6" md="4" lg="4">
                    <span class="custom-text">อายุ : </span>
                    <span class="custom-text ml-2">{{
                      ageCalcilar(selectPatient.birth_date)
                    }}</span
                    ><span class="custom-text ml-2">ปี</span>
                  </v-col>
                  <!-- <pre>{{selectPatient}}</pre> -->
                </v-row>
              </v-col>
              <v-col cols="12" class="pa-0 pt-3">
                <v-tabs
                  class="px-0"
                  v-model="tab"
                  background-color="#00a99d"
                  centered
                  dark
                  icons-and-text
                  fixed-tabs
                >
                  <v-tabs-slider></v-tabs-slider>

                  <v-tab href="#tab-1">
                    <span class="font-18">ประวัติการรักษา</span>
                    <v-icon>mdi-heart</v-icon>
                  </v-tab>

                  <v-tab href="#tab-2">
                    <span class="font-18">ประวัติการจ่ายยา</span>
                    <v-icon>mdi-pill</v-icon>
                  </v-tab>
                </v-tabs>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-tabs-items v-model="tab">
              <v-tab-item value="tab-1">
                <v-row class="ma-5 mt-8">
                  <v-col cols="12" md="3" lg="3">
                    <v-row class="card_pr">
                      <v-col
                        cols="12"
                        class="bg-white pl-0 pr-0 mb-5"
                        style="
                          min-height: 45vh;
                          border-radius: 10px;
                          border: 1px #00a99d solid;
                        "
                      >
                        <v-row class="pa-1 ml-2">
                          <v-col
                            cols="12"
                            class="py-5 font-18 w-700 text-00A99D"
                          >
                            <span>ประวัติการรักษา</span>
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>

                        <v-row class="pa-1 ml-2 mr-2">
                          <v-col align="center" cols="12" class="font-20 w-700">
                            <v-list dense>
                              <v-list-item-group
                                v-model="selectedItem"
                                @change="changeSelect"
                                mandatory
                              >
                                <v-list-item
                                  v-for="(item, index) in itemHistory"
                                  :key="index"
                                  class="my-1"
                                  style="
                                    border: 1px solid #e8e9e9;
                                    border-radius: 5px;
                                  "
                                  :value="item._id"
                                >
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <div class="d-flex flex-column" style="">
                                        <v-row class="pa-0 ma-0">
                                          <v-col
                                            cols="12"
                                            class="pb-2 text-left px-0"
                                          >
                                            <span class="w-500 font-16 mt-2">
                                              {{ item.patient_name }}
                                            </span>
                                          </v-col>
                                          <v-col
                                            cols="12"
                                            class="pb-2 text-left px-0"
                                          >
                                            <span class="w-500 font-16 mt-2">
                                              {{ displayDate(item.createdAt) }}
                                            </span>
                                          </v-col>
                                        </v-row>
                                      </div>
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list-item-group>
                            </v-list>
                          </v-col>
                          <v-col class="pa-0 ma-0">
                            <Pagination
                              :totals="total"
                              :isPage="page"
                              @page="changePage"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    md="9"
                    lg="9"
                    class="bg-white mb-5"
                    style="min-height: 45vh; border-radius: 10px"
                    v-if="showCurrent != null"
                  >
                    <v-row class="pr-0 pl-0">
                      <v-col
                        cols="12"
                        class="bg-white pl-0 pr-0"
                        style="min-height: 45vh; border-radius: 10px"
                      >
                        <v-row
                          class="ml-0 mr-0 mb-2"
                          style="border: 1px solid #00a99d; border-radius: 5px"
                        >
                          <v-col cols="6" lg="6" class="d-flex flex-column">
                            <span class="w-500 font-18 text-00A99D pb-5 pt-3"
                              >บันทึกทางการแพทย์</span
                            >
                            <v-divider></v-divider>

                            <div class="mt-3">
                              <span class="w-300 font-18 text-navy-50"
                                >อาการสำคัญ</span
                              >
                              <v-text-field
                                solo
                                dense
                                :readonly="true"
                                placeholder="กรอกอาการสำคัญ"
                                v-model="showCurrent.marjor_symptoms"
                              />
                            </div>
                            <div>
                              <span class="w-300 font-18 text-navy-50"
                                >อาการปัจจุบัน
                              </span>
                              <v-text-field
                                solo
                                dense
                                :readonly="true"
                                placeholder="กรอกอาการปัจจุบัน"
                                v-model="showCurrent.current_symptoms"
                              />
                            </div>
                            <div>
                              <span class="w-300 font-18 text-navy-50"
                                >โรคประจำตัว</span
                              >
                              <v-text-field
                                solo
                                :readonly="true"
                                dense
                                placeholder="กรอกโรคประจำตัว"
                                v-model="showCurrent.congenital_disease"
                              />
                            </div>
                            <div>
                              <span class="w-300 font-18 text-navy-50"
                                >บันทึกทางการแพทย์</span
                              >
                              <v-text-field
                                solo
                                dense
                                :readonly="true"
                                placeholder="กรอกบันทึกทางการแพทย์"
                                v-model="showCurrent.medical_record"
                                hide-details
                              />
                            </div>
                          </v-col>
                          <v-col
                            cols="6"
                            lg="6"
                            class="pr-0 pb-0"
                            style="border-left: 1px solid #00a99d"
                          >
                            <v-row
                              class="pa-2 mx-0"
                              style="height: 100%"
                              v-if="
                                selectedItem !== '' &&
                                selectedItem !== undefined
                              "
                            >
                              <div
                                v-for="(drug, index) in itemDrug"
                                :key="`${drug.id}-drug`"
                              >
                                <v-col
                                  cols="12"
                                  class="font-20 w-700 pb-2 pr-0 pl-0"
                                  v-if="showData(itemDrug, index)"
                                >
                                  <div v-if="drug.drug.length !== 0">
                                    <v-row class="ma-0 pa-0">
                                      <v-col
                                        class="d-flex pa-1 align-center"
                                        style="border-bottom: 1px #313b41 solid"
                                      >
                                        <span class="w-300 font-18 text-00A99D"
                                          >สั่งยา</span
                                        >
                                      </v-col>
                                    </v-row>
                                    <v-row
                                      class="ma-0 pa-0 mb-3"
                                      style="border-bottom: 1px #313b41 solid"
                                      v-if="drug.drug.length !== 0"
                                    >
                                      <v-col class="pa-1" cols="1">
                                        <span class="w-300 font-18 text-00A99D"
                                          >#</span
                                        >
                                      </v-col>
                                      <v-col class="pa-1" cols="4">
                                        <span class="w-300 font-18 text-00A99D"
                                          >รายการยา</span
                                        >
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="2"
                                        align="center"
                                      >
                                        <span class="w-300 font-18 text-00A99D"
                                          >จำนวน</span
                                        >
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="2"
                                        align="center"
                                      >
                                        <span class="w-300 font-18 text-00A99D"
                                          >ราคา</span
                                        >
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="2"
                                        align="center"
                                      >
                                        <span class="w-300 font-18 text-00A99D"
                                          >ราคารวม
                                        </span>
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="1"
                                        align="center"
                                      >
                                        <span class="w-300 font-18 text-313B41">
                                        </span>
                                      </v-col>
                                    </v-row>

                                    <v-row
                                      class="ma-0 pa-0"
                                      v-for="(item, index) in drug.drug"
                                      :key="index"
                                    >
                                      <v-col
                                        class="pa-1"
                                        cols="1"
                                        align-self="center"
                                      >
                                        <span
                                          class="w-300 font-18 text-313B41"
                                          >{{ index + 1 }}</span
                                        >
                                      </v-col>
                                      <v-col class="pa-1" cols="4">
                                        <span class="w-300 font-18 text-313B41">
                                          <v-text-field
                                            class="text-field"
                                            :value="item.name_drug"
                                            outlined
                                            dense
                                            small
                                            hide-details
                                          ></v-text-field>
                                        </span>
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="2"
                                        align="center"
                                      >
                                        <span class="w-300 font-18 text-313B41">
                                          <v-text-field
                                            class="text-field"
                                            type="number"
                                            v-model="item.count"
                                            outlined
                                            dense
                                            small
                                            hide-details
                                            :min="0"
                                          ></v-text-field>
                                        </span>
                                      </v-col>
                                      <v-col
                                        class="pa-1 text-center"
                                        cols="2"
                                        align="center"
                                      >
                                        <span class="w-300 font-18 text-313B41">
                                          <v-text-field
                                            class="text-field"
                                            :value="item.price"
                                            outlined
                                            dense
                                            small
                                            readonly
                                            hide-details
                                          ></v-text-field>
                                        </span>
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="2"
                                        align="center"
                                        text-align="center"
                                      >
                                        <span class="w-300 font-18 text-313B41">
                                          <v-text-field
                                            class="text-field"
                                            :value="item.total"
                                            outlined
                                            dense
                                            small
                                            readonly
                                            hide-details
                                          ></v-text-field>
                                        </span>
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="1"
                                        align="center"
                                        text-align="center"
                                      >
                                      </v-col>

                                      <v-col
                                        class="pa-1"
                                        cols="1"
                                        align-self="center"
                                      ></v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="10"
                                        align-self="center"
                                      >
                                        <v-row class="usageAndAdvice">
                                          <v-col
                                            class="pa-1"
                                            cols="12"
                                            align-self="center"
                                            style="
                                              white-space: wrap;
                                              text-overflow: ellipsis;
                                            "
                                          >
                                            <span
                                              class="w-700 font-14 text-313B41"
                                            >
                                              ข้อมูลการใช้ยา :
                                            </span>
                                            <span
                                              class="w-300 font-14 text-313B41"
                                            >
                                              {{ item.usage || "-" }}
                                            </span>
                                          </v-col>
                                          <v-col
                                            class="pa-1"
                                            cols="12"
                                            align-self="center"
                                            style="text-align: center"
                                            v-if="item.advice"
                                          >
                                            <span
                                              class="w-700 font-12 text-EB5757"
                                            >
                                              ***
                                              {{ item.advice }}
                                              ***
                                            </span>
                                          </v-col>
                                        </v-row>
                                      </v-col>
                                    </v-row>
                                    <v-col
                                      cols="12"
                                      class="d-flex justify-center"
                                    >
                                      <span
                                        >สรุปยอดรายการยา
                                        {{ sum(index) }} บาท</span
                                      >
                                    </v-col>
                                  </div>
                                </v-col>
                              </div>

                              <v-row
                                class="pa-0 ma-0"
                                v-if="
                                  showCurrent == null ||
                                  showCurrent.drug_list.length == 0
                                "
                              >
                                <v-col
                                  cols="12"
                                  class="noitems d-flex justify-center align-center text-center"
                                >
                                  <span class="font-18 w-700 text-00A99D"
                                    >ไม่มีรายการยา</span
                                  >
                                </v-col>
                              </v-row>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item value="tab-2">
                <v-row class="ma-5 mt-8">
                  <v-col cols="12" md="3" lg="3">
                    <v-row class="card_pr">
                      <v-col
                        cols="12"
                        class="bg-white pl-0 pr-0 mb-5"
                        style="
                          min-height: 45vh;
                          border-radius: 10px;
                          border: 1px #00a99d solid;
                        "
                      >
                        <v-row class="pa-1 ml-2">
                          <v-col
                            cols="12"
                            class="py-5 font-18 w-700 text-00A99D"
                          >
                            <span>ประวัติการจ่ายยา</span>
                          </v-col>
                        </v-row>
                        <v-divider></v-divider>

                        <v-row class="pa-1 ml-2 mr-2">
                          <v-col align="center" cols="12" class="font-20 w-700">
                            <v-list dense>
                              <v-list-item-group
                                v-model="selectedItem2"
                                @change="changeSelect2"
                                mandatory
                              >
                                <v-list-item
                                  v-for="(item, index) in itemPrescription"
                                  :key="index"
                                  class="my-1"
                                  style="
                                    border: 1px solid #e8e9e9;
                                    border-radius: 5px;
                                  "
                                  :value="item._id"
                                >
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      <div class="d-flex flex-column" style="">
                                        <v-row class="pa-0 ma-0">
                                          <v-col
                                            cols="12"
                                            class="pb-2 text-left px-0"
                                          >
                                            <span class="w-500 font-16 mt-2">
                                              {{ item.patient_name }}
                                            </span>
                                          </v-col>
                                          <v-col
                                            cols="12"
                                            class="pb-2 text-left px-0"
                                          >
                                            <span class="w-500 font-16 mt-2">
                                              {{ displayDate(item.updatedAt) }}
                                            </span>
                                          </v-col>
                                        </v-row>
                                      </div>
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list-item-group>
                            </v-list>
                          </v-col>
                          <v-col class="pa-0 ma-0">
                            <Pagination
                              :totals="totalPrescpt"
                              :isPage="pagePrescpt"
                              @page="changePagePrescpt"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col
                    cols="12"
                    md="9"
                    lg="9"
                    class="bg-white mb-5"
                    style="min-height: 45vh;  border-radius: 10px"
                    v-if="showCurrent2 != null"
                  >
                    <v-row class="pr-0 pl-0">
                      <v-col
                        cols="12"
                        class="bg-white pl-0 pr-0"
                        style="min-height: 45vh; border-radius: 10px"
                      >
                        <v-row
                          class="ml-0 mr-0 mb-2"
                          style="border: 1px solid #00a99d; border-radius: 5px"
                        >
                          <v-col cols="12" lg="12">
                            <v-row
                              class="pa-2 mx-0"
                              style="height: 100%"
                              v-if="
                                selectedItem2 !== '' &&
                                selectedItem2 !== undefined
                              "
                            >
                              <div
                                v-for="(drug, index) in itemDrug2"
                                :key="`${drug.id}-drug`"
                              >
                                <v-col
                                  cols="12"
                                  class="font-20 w-700 pb-2 pr-0 pl-0"
                                  v-if="showData2(itemDrug2, index)"
                                >
                                  <div v-if="drug.drug.length !== 0">
                                    <v-row class="ma-0 pa-0">
                                      <v-col
                                        class="d-flex pa-1 align-center"
                                        style="border-bottom: 1px #313b41 solid"
                                      >
                                        <span class="w-300 font-18 text-00A99D"
                                          >สั่งยา</span
                                        >
                                      </v-col>
                                    </v-row>
                                    <v-row
                                      class="ma-0 pa-0 mb-3"
                                      style="border-bottom: 1px #313b41 solid"
                                      v-if="drug.drug.length !== 0"
                                    >
                                      <v-col class="pa-1" cols="1">
                                        <span class="w-300 font-18 text-00A99D"
                                          >#</span
                                        >
                                      </v-col>
                                      <v-col class="pa-1" cols="4">
                                        <span class="w-300 font-18 text-00A99D"
                                          >รายการยา</span
                                        >
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="2"
                                        align="center"
                                      >
                                        <span class="w-300 font-18 text-00A99D"
                                          >จำนวน</span
                                        >
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="2"
                                        align="center"
                                      >
                                        <span class="w-300 font-18 text-00A99D"
                                          >ราคา</span
                                        >
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="2"
                                        align="center"
                                      >
                                        <span class="w-300 font-18 text-00A99D"
                                          >ราคารวม
                                        </span>
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="1"
                                        align="center"
                                      >
                                        <span class="w-300 font-18 text-00A99D">
                                          สถานะ
                                        </span>
                                      </v-col>
                                    </v-row>

                                    <v-row
                                      class="ma-0 pa-0"
                                      v-for="(item, index) in drug.drug"
                                      :key="index"
                                    >
                                      <v-col
                                        class="pa-1"
                                        cols="1"
                                        align-self="center"
                                      >
                                        <span
                                          class="w-300 font-18 text-313B41"
                                          >{{ index + 1 }}</span
                                        >
                                      </v-col>
                                      <v-col class="pa-1" cols="4">
                                        <span class="w-300 font-18 text-313B41">
                                          <v-text-field
                                            class="text-field"
                                            :value="item.name_drug"
                                            outlined
                                            dense
                                            small
                                            hide-details
                                            readonly
                                          ></v-text-field>
                                        </span>
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="2"
                                        align="center"
                                      >
                                        <span class="w-300 font-18 text-313B41">
                                          <v-text-field
                                            class="text-field"
                                            type="number"
                                            v-model="item.count"
                                            outlined
                                            dense
                                            small
                                            hide-details
                                            :min="0"
                                            readonly
                                          ></v-text-field>
                                        </span>
                                      </v-col>
                                      <v-col
                                        class="pa-1 text-center"
                                        cols="2"
                                        align="center"
                                      >
                                        <span class="w-300 font-18 text-313B41">
                                          <v-text-field
                                            class="text-field"
                                            :value="item.price"
                                            outlined
                                            dense
                                            small
                                            readonly
                                            hide-details
                                          ></v-text-field>
                                        </span>
                                      </v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="2"
                                        align="center"
                                        text-align="center"
                                      >
                                        <span class="w-300 font-18 text-313B41">
                                          <v-text-field
                                            class="text-field"
                                            :value="item.total"
                                            outlined
                                            dense
                                            small
                                            readonly
                                            hide-details
                                          ></v-text-field>
                                        </span>
                                      </v-col>
                                      <v-col
                                        v-if="item.status !== false"
                                        class="pa-1"
                                        cols="1"
                                        align="center"
                                        text-align="center"
                                      >
                                        <v-chip
                                          class="ma-2"
                                          color="green"
                                          text-color="white"
                                        >
                                          <v-icon size="18px" left>
                                            mdi-checkbox-marked-circle-outline
                                          </v-icon>
                                          <span class="font-10"> จ่ายยา</span>
                                         
                                        </v-chip>
                                      </v-col>
                                      <v-col
                                        v-else
                                        class="pa-1"
                                        cols="1"
                                        align="center"
                                        text-align="center"
                                      >
                                        <v-chip
                                          class="ma-2"
                                          color="red"
                                          text-color="white"
                                        
                                          ><v-icon size="18px" left>
                                            mdi-close-circle-outline
                                          </v-icon>
                                          <span class="font-10 mr-4 ma-0"> ไม่จ่ายยา</span>
                                        </v-chip>
                                      </v-col>

                                      <v-col
                                        class="pa-1"
                                        cols="1"
                                        align-self="center"
                                      ></v-col>
                                      <v-col
                                        class="pa-1"
                                        cols="10"
                                        align-self="center"
                                      >
                                        <v-row class="usageAndAdvice">
                                          <v-col
                                            class="pa-1"
                                            cols="12"
                                            align-self="center"
                                            style="
                                              white-space: wrap;
                                              text-overflow: ellipsis;
                                            "
                                          >
                                            <span
                                              class="w-700 font-14 text-313B41"
                                            >
                                              ข้อมูลการใช้ยา :
                                            </span>
                                            <span
                                              class="w-300 font-14 text-313B41"
                                            >
                                              {{ item.usage || "-" }}
                                            </span>
                                          </v-col>
                                          <v-col
                                            class="pa-1"
                                            cols="12"
                                            align-self="center"
                                            style="text-align: center"
                                            v-if="item.advice"
                                          >
                                            <span
                                              class="w-700 font-12 text-EB5757"
                                            >
                                              ***
                                              {{ item.advice }}
                                              ***
                                            </span>
                                          </v-col>
                                        </v-row>
                                      </v-col>
                                    </v-row>
                                    <v-col
                                      cols="12"
                                      class="d-flex justify-center"
                                    >
                                      <span
                                        >สรุปยอดรายการยา
                                        {{ sum2(index) }} บาท</span
                                      >
                                    </v-col>
                                  </div>
                                </v-col>
                              </div>

                              <v-row
                                class="pa-0 ma-0"
                                v-if="
                                  showCurrent2 == null ||
                                  showCurrent2.drug_list.length == 0
                                "
                              >
                                <v-col
                                  cols="12"
                                  class="noitems d-flex justify-center align-center text-center"
                                >
                                  <span class="font-18 w-700 text-00A99D"
                                    >ไม่มีรายการยา</span
                                  >
                                </v-col>
                              </v-row>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>

        <!-- <Pagination :totals="0" :isPage="page" @page="changePage" /> -->
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { Pagination } from "@/components/pagination";
import functioncryto from "@/services/encrypt.js";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      tab: "",
      dialog: false,
      selectedItem: "",
      selectedItem2: "",
      headers: [
        {
          text: "สถานะการโทร",
          value: "no",
          sortable: false,
          align: "center",
          width: "15%",
        },
        {
          text: "ผู้สนทนาปลายทาง",
          align: "left",
          sortable: false,
          value: "name",
          width: "30%",
        },
        {
          text: "ผู้ป่วยที่ทำการรักษา",
          align: "left",
          sortable: false,
          value: "patient",
          width: "30%",
        },
        {
          text: "วันที่โทร",
          align: "left",
          sortable: false,
          value: "createdAt",
          width: "15%",
        },
      ],
      itemPrescription: [],
      itemHistory: [],
      itemDrug: [],
      itemDrug2: [],
      showCurrent: null,
      showCurrent2: null,
      selectPatient: {},
      total: 0,
      page: 1,
      totalPrescpt: 0,
      pagePrescpt: 1,
    };
  },
  mounted() {
    this.getPrescription();
    this.getHistory();
  },
  computed: {
    almost_mobile() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    open(item) {
      this.selectPatient = item.patient;
      this.getPrescription();
      this.getHistory();
      this.dialog = true;
    },
    changeSelect(e) {
      if (e) this.showCurrent = this.itemHistory.find((obj) => obj._id === e);
      else this.showCurrent = null;
    },
    changeSelect2(e) {
      if (e)
        this.showCurrent2 = this.itemPrescription.find((obj) => obj._id === e);
      else this.showCurrent2 = null;
    },
    async getHistory() {
      try {
        const params = new URLSearchParams();
        params.append("page", this.page || 1);
        params.append("limit", 10);
        params.append("biz_id", sessionStorage.biz_id);
        params.append(
          "search",
          this.selectPatient.one_id !== "" && this.selectPatient.one_id !== null
            ? this.selectPatient.one_id
            : this.selectPatient.userqr_id
        );

        const { data: { data, result } = {} } = await this.axios.get(
          `${process.env.VUE_APP_BACKEND_URL}/v1/diagnostic-histories/patient?${params}`
        );

        if (result == "success") {
          if (data[0]) {
            this.itemDrug = [];
            const { data: searchData, metadata } = data[0];
            const { total } = metadata[0];
            this.total = total;
            this.itemHistory = searchData;
            searchData.forEach((element) => {
              this.itemDrug.push({ id: element._id, drug: element.drug_list });
            });
            // console.log("itemHistory",this.itemHistory);
          }
        }
      } catch (error) {
        console.error();
      }
    },
    async getPrescription() {
      try {
        const params = new URLSearchParams();
        params.append("page", this.pagePrescpt || 1);
        params.append("limit", 10);
        if (
          this.selectPatient.one_id !== "" &&
          this.selectPatient.one_id !== null
        ) {
          params.append("patient_id", this.selectPatient.one_id);
        } else {
          params.append("patient_cid", this.selectPatient.cid);
        }
        params.append("biz_id", sessionStorage.biz_id);
        params.append("status", "confirm");
        const { data: { data, result } = {} } = await this.axios.get(
          `${process.env.VUE_APP_BACKEND_URL}/v1/prescription?${params}`
        );
        if (result == "success") {
          if (data[0]) {
            this.itemDrug2 = [];
            const { data: searchData, metadata } = data[0];
            const { total } = metadata[0];
            this.totalPrescpt = total;
            this.itemPrescription = searchData;
            searchData.forEach((element) => {
              this.itemDrug2.push({ id: element._id, drug: element.drug_list });
            });
            // console.log("itemPrescription",this.itemPrescription);
          }
        }
      } catch (error) {
        console.error();
      }
    },
    formatDate(data) {
      if (!data) {
        return null;
      }

      let datetime = new Date(
        new Date(data) - new Date().getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, -1)
        .substr(0, 10);
      var [year, month, day] = datetime.split("-");
      return `${day}/${month}/${parseInt(year) + 543}`;
    },
    displayDate(date) {
      if (!date) return "-";
      return moment(date)
        .locale("th")
        .add(543, "years")
        .format("DD MMMM YYYY HH:mm น.");
    },
    changePage(e) {
      this.page = e;
      this.getHistory();
    },
    changePagePrescpt(e) {
      this.pagePrescpt = e;
      this.getPrescription();
    },
    showData(item, index) {
      if (item[index].id == this.selectedItem) {
        return true;
      }
    },
    showData2(item, index) {
      if (item[index].id == this.selectedItem2) {
        return true;
      }
    },
    close() {
      this.dialog = false;
      this.itemPrescription = [];
      this.itemHistory = [];
      this.tab = "tab-1";
      this.total = 0;
      this.page = 1;
      this.totalPrescpt = 0;
      this.pagePrescpt = 1;
    },
    displayName(item) {
      if (item.patient) {
        const {
          patient: { account_title_th, first_name_th, last_name_th } = {},
        } = item;

        return `${account_title_th} ${first_name_th} ${last_name_th}`;
      }
      return "-";
    },
    displayCID(cid) {
      if (cid) {
        const maskedDigits = "X".repeat(6);
        const visibleDigits = functioncryto.decrypt(cid).substring(6);
        return maskedDigits + visibleDigits;
      } else return "";
    },
    ageCalcilar(birth) {
      const today = new Date();
      const birthDate = new Date(birth);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }

      return age;
    },
    genderPerson(account_title_th) {
      if (account_title_th) {
        if (["เด็กชาย", "นาย"].includes(account_title_th)) return "ชาย";
        if (["เด็กหญิง", "นางสาว", "นาง"].includes(account_title_th))
          return "หญิง";
      } else {
        return "";
      }
    },
    sum(index) {
      if (this.itemDrug[index].drug) {
        return this.itemDrug[index].drug.reduce(
          (total, drug) => total + drug.total,
          0
        );
      }

      return "";
    },
    sum2(index) {
      if (this.itemDrug2[index].drug) {
        return this.itemDrug2[index].drug
          .filter((drug) => drug.status === true)
          .reduce((total, drug) => total + drug.total, 0);
      }

      return "";
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background: #00a99d;
  color: white;
}
.table-viewdoc th {
  background: #ceefed !important;
  color: #00a99d !important;
}
.card_pr {
  padding-right: 12px;
}
.usageAndAdvice {
  border: 1px solid #bdbdbd;
  border-radius: 4px;
  margin: 0px;
}
.noitems {
  height: 50vh;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}
.v-list-item-group .v-list-item--active {
  background: #4ba69d;
  color: #fff;
}
.theme--light.v-list-item:not(.v-list-item--active):not(
    .v-list-item--disabled
  ) {
  background: #d5eeed;
}
.custom-text {
  font-size: 18px;
  color: black;
}
</style>
